import React from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../Breadcrumb";
import bannerIMG from "../assets/bannerImages/BD-Img.png";
import { Link } from "react-router-dom";
import plusicon from '../assets/img/product_img/plusicon.png';
import "../pages/BlogDetails.css";
import WhatsappButton from "../components/WhatsappButton";




const blogData = [
  {
    id: "1",
    newtitle: "ChoosetheRightTrampolineParkManufacturer",
    title: "How to Choose the Right Trampoline Park Manufacturer for Your Business",
    introduction: "Starting a trampoline park is an exciting opportunity—but choosing the right manufacturer is critical to your success. The right partner ensures safety, innovation, and profitability.",
    sections: [
      {
        heading: "What to Look For in a Trampoline Park Manufacturer",
        content: [
          "Safety Certifications: Look for manufacturers who follow ASTM, TUV, and EN standards.",
          "Customization Capabilities: Can they design to your theme, space, and budget?",
          "Experience: Do they have proven installations in global markets?",
          "Turnkey Solutions: From design to installation and after-sales support.",
        ],
      },
      {
        heading: "Why GEMPLAY Is a Trusted Global Partner",
        content: [
          "10+ years of manufacturing experience in trampoline parks and family entertainment centers.",
          "Full in-house design, production, and installation team.",
          "Successfully delivered projects in Jordan, UAE, Saudi Arabia, Germany, and the USA.",
        ],
      },
    ],
    conclusion: "Choosing the right trampoline park manufacturer isn’t just a decision—it’s an investment in your success. Contact GEMPLAY today to get started.",
  },
  {
    id: "2",
    newtitle: "ProcessofTrampolinePark",
    title: "The Process of Building a Custom Trampoline Park with GEMPLAY",
    introduction: "Wondering how a custom trampoline park is built from concept to completion? Here’s how GEMPLAY, a leading trampoline park manufacturer, brings your vision to life.",
    sections: [
      {
        heading: "Consultation & Concept Design",
        content: [
          "We understand your goals, space, and target audience.",
          "3D visualizations and layout planning."
        ]
      },
      {
        heading: "Engineering & Production",
        content: [
          "We use premium materials and follow strict safety standards.",
          "Our in-house factory ensures fast, controlled manufacturing."
        ]
      },
      {
        heading: "Shipping & Installation",
        content: [
          "We coordinate international logistics.",
          "Our trained technicians ensure precise, safe installation."
        ]
      },
      {
        heading: "Post-Installation Support",
        content: [
          "Maintenance guidance, spare parts, and technical support.",
          "Staff training and safety operations manual."
        ]
      }
    ],
    conclusion: "From idea to reality, GEMPLAY manages every detail. Want a trampoline park that stands out? Let us build it for you."
  },
  {
    id: "3",
    title: "Why Trampoline Parks Are Booming Worldwide (And How to Get Started)",
    newtitle: "TrampolineParksAreBooming",
    introduction: "Trampoline parks have become a global trend in family entertainment. Whether in malls, entertainment centers, or stand-alone venues—they’re drawing huge crowds.",
    sections: [
      {
        heading: "Why Trampoline Parks Are Popular",
        content: [
          "Active fun for all ages",
          "Low operating costs with high ROI",
          "Great for birthday parties, events, and fitness"
        ]
      },
      {
        heading: "Business Opportunity: What You Need",
        content: [
          "A suitable space (starting from 300 sqm)",
          "A reliable trampoline park manufacturer",
          "A marketing plan and operational staff"
        ]
      },
      {
        heading: "How GEMPLAY Supports New Trampoline Park Businesses",
        content: [
          "Full design + safety compliance",
          "Support with themes, branding, and operations",
          "Global shipping and multilingual support"
        ]
      }
    ],
    conclusion: "If you’re looking to start or expand your family entertainment business, trampoline parks offer unmatched potential. GEMPLAY is ready to be your manufacturing partner worldwide."
  },
  {
    id: "4",
    title: "Why GEMPLAY Is the Leading Indoor Playground Manufacturer in Jordan",
    newtitle: "IndoorPlaygroundManufacturer",
    introduction: "With the rising demand for family-friendly entertainment in Jordan, the need for high-quality indoor playgrounds has never been greater. GEMPLAY is proud to be Jordan’s premier indoor playground manufacturer—offering innovative, safe, and fully customized play solutions.",
    sections: [
      {
        heading: "What Sets GEMPLAY Apart in Jordan",
        content: [
          "Local expertise with international quality standards (EN, ASTM, TUV)",
          "Custom design for malls, schools, restaurants, and entertainment centers",
          "Fast delivery and local installation teams"
        ]
      },
      {
        heading: "Products We Specialize In",
        content: [
          "Indoor play structures",
          "Soft play equipment",
          "Ball pits, tunnels, slides, and climbing frames",
          "Themed environments for cafes, nurseries, and shopping centers"
        ]
      },
      {
        heading: "Benefits of Working with a Local Manufacturer",
        content: [
          "Faster support and maintenance",
          "Better understanding of Jordanian market and safety regulations",
          "Cost-effective logistics"
        ]
      }
    ],
    conclusion: "Whether you're planning a mall play zone or a private nursery, GEMPLAY delivers top-quality playground solutions made in Jordan. Contact us today for a free design consultation."
  },
  {
    id: "5",
    title: "How to Start Your Indoor Playground Business in Jordan",
    newtitle: "IndoorPlaygroundBusiness",
    introduction: "Indoor playgrounds are a growing business opportunity in Jordan, especially in urban areas like Amman, Irbid, and Aqaba. If you're considering starting your own, here’s a step-by-step guide—with expert support from GEMPLAY, Jordan’s trusted playground manufacturer.",
    sections: [
      {
        heading: "Step 1: Find the Right Location",
        content: [
          "Malls, gyms, cafes, or independent centers",
          "Minimum space: 100–200 sqm"
        ]
      },
      {
        heading: "Step 2: Choose a Certified Manufacturer",
        content: [
          "Work with GEMPLAY for design, safety, and manufacturing",
          "All equipment complies with international safety standards"
        ]
      },
      {
        heading: "Step 3: Customize Your Playground Theme",
        content: [
          "Jungle, underwater, space, or cartoon themes",
          "Soft play areas, trampolines, wall games, and sensory elements"
        ]
      },
      {
        heading: "Step 4: Installation & Training",
        content: [
          "Our Jordan-based team handles everything",
          "We provide staff training and safety manuals"
        ]
      }
    ],
    conclusion: "You bring the vision—we bring the playground. GEMPLAY is your local partner for indoor playground success in Jordan and beyond."
  },
  {
    id: "6",
    newtitle: "UAESchoolsAreChoosingIndoorPlaygrounds",
    title: " 5 Reasons UAE Schools Are Choosing Indoor Playgrounds",
    introduction: "Supporting Student Development in Climate-Friendly, Engaging Spaces. Schools across the UAE are reimagining learning environments to support whole-child development—and indoor playgrounds are leading the way.",
    sections: [
      {
        heading: "1. All-Season Usability",
        content: [
          "Unlike outdoor areas, indoor playgrounds provide consistent, comfortable use regardless of temperature or dust conditions."
        ]
      },
      {
        heading: "2. Promotes Active Learning",
        content: [
          "Through climbing, crawling, and imaginative play, kids enhance motor skills and brain development."
        ]
      },
      {
        heading: "3. Supports School Branding",
        content: [
          "A well-equipped indoor play area sets schools apart during admissions and school tours."
        ]
      },
      {
        heading: "4. Helps Manage Student Behavior ",
        content: [
          "Play breaks reduce stress, improve mood, and support better behavior in the classroom."
        ]
      },
      {
        heading: "5. Increases Student Satisfaction & Retention",
        content: [
          "Happier students stay engaged—leading to improved retention and a more vibrant school culture."
        ]
      }
    ],
    conclusion: "For schools in the UAE aiming to raise standards in education and well-being, indoor playgrounds are more than a trend—they’re a strategic investment in student success."
  },
  // {
  // id: "7",
  // title: "Top 7 Benefits of Visiting a Trampoline Park for Family Fun",
  // introduction: "In today's fast-paced digital world, finding a fun and active way for families to spend time together can be a challenge. That’s where GEM Trampoline Parks come in — offering more than just a bounce! Whether you're in Jordan, UAE, Saudi Arabia, Germany, or the USA, trampoline parks are quickly becoming the go-to destination for energetic, screen-free family experiences. ",
  // sections: [
  //     {
  //         heading: "1. Active Fun for All Ages",
  //         content: [
  //             "From toddlers to teens, parents to grandparents — everyone can enjoy bouncing. GEM parks are designed with multi-age zones to ensure everyone can participate safely and comfortably."
  //         ]
  //     },
  //     {
  //         heading: "2. Unplug & Reconnect",
  //         content: [
  //             "Ditch the screens and rediscover real connection. Trampoline parks provide a shared experience that brings families together through laughter, games, and challenges."
  //         ]
  //     },
  //     {
  //         heading: "3. Health Benefits Without the Boredom ",
  //         content: [
  //             "Jumping is a full-body workout that improves cardiovascular health, boosts metabolism, and enhances balance. It’s a fun way to stay fit — and your kids won’t even realize they’re exercising!"
  //         ]
  //     },
  //     {
  //         heading: "4. Stress Relief Through Movement",
  //         content: [
  //             "Physical activity, especially one that involves play, is a natural stress reliever. Bouncing, flipping, and flying through the air releases endorphins — the “feel-good” hormones. "
  //         ]
  //     },
  //     {
  //         heading: "5. Safe, Supervised Play",
  //         content: [
  //             "GEM Trampoline Parks follow the highest safety standards, including certified foam pits, padded surfaces, and trained staff. Parents can relax knowing the environment is fun and safe. "
  //         ]
  //     },
  //     {
  //         heading: "6. Perfect for Celebrations ",
  //         content: [
  //             "Whether it’s a birthday, school break, or family reunion, trampoline parks provide the ideal setting for group fun. With private party rooms and customizable packages, celebrations at GEM are unforgettable."
  //         ]
  //     },
  //     {
  //         heading: "7. Indoor Fun, Year-Round",
  //         content: [
  //             "Rain or shine, hot or cold — indoor trampoline parks are climate-controlled and ready for action any day of the year. It’s the perfect escape for family fun during extreme weather. "
  //         ]
  //     }
  //     ],
  //     conclusion: "Whether you're planning a weekend adventure or a special occasion, GEM Trampoline Parks offer a safe, thrilling, and health-boosting experience for the whole family."
  // },
  // {
  // id: "8",
  // title: "Starting a Trampoline Park in the Middle East: What You Need to Know",
  // introduction: "The Middle East is witnessing a dynamic shift in how families and youth engage in entertainment — with trampoline parks leading the charge. As demand for active indoor entertainment continues to rise, especially in countries like the UAE, Saudi Arabia, Jordan, and the Gulf, savvy entrepreneurs are exploring this booming sector. If you’re considering launching a trampoline park in the Middle East, here’s what you need to know — from market demand to ROI expectations and safety compliance. ",
  // sections: [
  //     {
  //         heading: "1. Active Fun for All Ages",
  //         content: [
  //             "From toddlers to teens, parents to grandparents — everyone can enjoy bouncing. GEM parks are designed with multi-age zones to ensure everyone can participate safely and comfortably."
  //         ]
  //     },
  //     {
  //         heading: "2. Unplug & Reconnect",
  //         content: [
  //             "Ditch the screens and rediscover real connection. Trampoline parks provide a shared experience that brings families together through laughter, games, and challenges."
  //         ]
  //     },
  //     {
  //         heading: "3. Health Benefits Without the Boredom ",
  //         content: [
  //             "Jumping is a full-body workout that improves cardiovascular health, boosts metabolism, and enhances balance. It’s a fun way to stay fit — and your kids won’t even realize they’re exercising!"
  //         ]
  //     },
  //     {
  //         heading: "4. Stress Relief Through Movement",
  //         content: [
  //             "Physical activity, especially one that involves play, is a natural stress reliever. Bouncing, flipping, and flying through the air releases endorphins — the “feel-good” hormones. "
  //         ]
  //     },
  //     {
  //         heading: "5. Safe, Supervised Play",
  //         content: [
  //             "GEM Trampoline Parks follow the highest safety standards, including certified foam pits, padded surfaces, and trained staff. Parents can relax knowing the environment is fun and safe. "
  //         ]
  //     },
  //     {
  //         heading: "6. Perfect for Celebrations ",
  //         content: [
  //             "Whether it’s a birthday, school break, or family reunion, trampoline parks provide the ideal setting for group fun. With private party rooms and customizable packages, celebrations at GEM are unforgettable."
  //         ]
  //     },
  //     {
  //         heading: "7. Indoor Fun, Year-Round",
  //         content: [
  //             "Rain or shine, hot or cold — indoor trampoline parks are climate-controlled and ready for action any day of the year. It’s the perfect escape for family fun during extreme weather. "
  //         ]
  //     }
  //     ],
  //     conclusion: "Whether you're planning a weekend adventure or a special occasion, GEM Trampoline Parks offer a safe, thrilling, and health-boosting experience for the whole family."
  // },
  // {
  // id: "9",
  // title: "Top 7 Benefits of Visiting a Trampoline Park for Family Fun",
  // introduction: "In today's fast-paced digital world, finding a fun and active way for families to spend time together can be a challenge. That’s where GEM Trampoline Parks come in — offering more than just a bounce! Whether you're in Jordan, UAE, Saudi Arabia, Germany, or the USA, trampoline parks are quickly becoming the go-to destination for energetic, screen-free family experiences. ",
  // sections: [
  //     {
  //         heading: "1. Active Fun for All Ages",
  //         content: [
  //             "From toddlers to teens, parents to grandparents — everyone can enjoy bouncing. GEM parks are designed with multi-age zones to ensure everyone can participate safely and comfortably."
  //         ]
  //     },
  //     {
  //         heading: "2. Unplug & Reconnect",
  //         content: [
  //             "Ditch the screens and rediscover real connection. Trampoline parks provide a shared experience that brings families together through laughter, games, and challenges."
  //         ]
  //     },
  //     {
  //         heading: "3. Health Benefits Without the Boredom ",
  //         content: [
  //             "Jumping is a full-body workout that improves cardiovascular health, boosts metabolism, and enhances balance. It’s a fun way to stay fit — and your kids won’t even realize they’re exercising!"
  //         ]
  //     },
  //     {
  //         heading: "4. Stress Relief Through Movement",
  //         content: [
  //             "Physical activity, especially one that involves play, is a natural stress reliever. Bouncing, flipping, and flying through the air releases endorphins — the “feel-good” hormones. "
  //         ]
  //     },
  //     {
  //         heading: "5. Safe, Supervised Play",
  //         content: [
  //             "GEM Trampoline Parks follow the highest safety standards, including certified foam pits, padded surfaces, and trained staff. Parents can relax knowing the environment is fun and safe. "
  //         ]
  //     },
  //     {
  //         heading: "6. Perfect for Celebrations ",
  //         content: [
  //             "Whether it’s a birthday, school break, or family reunion, trampoline parks provide the ideal setting for group fun. With private party rooms and customizable packages, celebrations at GEM are unforgettable."
  //         ]
  //     },
  //     {
  //         heading: "7. Indoor Fun, Year-Round",
  //         content: [
  //             "Rain or shine, hot or cold — indoor trampoline parks are climate-controlled and ready for action any day of the year. It’s the perfect escape for family fun during extreme weather. "
  //         ]
  //     }
  //     ],
  //     conclusion: "Whether you're planning a weekend adventure or a special occasion, GEM Trampoline Parks offer a safe, thrilling, and health-boosting experience for the whole family."
  // },
  // Add more blogs here
];


const BlogDetails = () => {
  const { id } = useParams();
  console.log("id from blog page", id);

  const blog = blogData.find((item) => item.newtitle === id);

  if (!blog) {
    return <p>Blog not found!</p>;
  }




  return (
    <div>
      <Header />
      <div >
        <WhatsappButton
          altText="Chat with us on WhatsApp"
          iconSize={70}
        />
        <Link to="/getquotations" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div className="icon-container">
            <img
              src={plusicon}
              alt="highest quality trampoline"
              className="Producticon"
              style={{ cursor: "pointer" }}
            />
            <button className="quotation-button">Get Quotation</button>
          </div>
        </Link>
      </div>




      <div className="p-img-box" style={{ position: "relative", display: "inline-block" }}>

        <img src={bannerIMG} alt="highest quality trampoline" className="main-img" />
        <div
          className="breadcrumb-overlay"
          style={{
            position: "absolute",
            top: '110%',
            left: "16%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Breadcrumb textColor="#000" />
        </div>
      </div>

      {/* <div className="content">
        <div className="contentHeader">
            <h1>Why Trampoline Parks Are Booming Worldwide (And How to Get Started)</h1>
            <p>Trampoline parks have become a global trend in family entertainment. Whether in malls, entertainment centers, or stand-alone venues—they’re drawing huge crowds.</p>
        
        </div>
       
        <section>
          <h2>Why Trampoline Parks Are Popular</h2>
          <ul>
            <li>Active fun for all ages</li>
            <li>Low operating costs with high ROI</li>
            <li>Great for birthday parties, events, and fitness</li>
          </ul>
        </section>
        
        <section>
          <h2>Business Opportunity: What You Need</h2>
          <ul>
            <li>A suitable space (starting from 300 sqm)</li>
            <li>A reliable trampoline park manufacturer</li>
            <li>A marketing plan and operational staff</li>
          </ul>
        </section>
        
        <section>
          <h2>How GEMPLAY Supports New Trampoline Park Businesses</h2>
          <ul>
            <li>Full design + safety compliance</li>
            <li>Support with themes, branding, and operations</li>
            <li>Global shipping and multilingual support</li>
          </ul>
        </section>
        
        <section className="conclusion">
          <h2>Conclusion</h2>
          <p>If you’re looking to start or expand your family entertainment business, trampoline parks offer unmatched potential. GEMPLAY is ready to be your manufacturing partner worldwide.</p>
        </section>
      </div> */}

      <div className="blogContent">
        <div className="contentHeader">
          <h1>{blog.title}</h1>
          <p>{blog.introduction}</p>
        </div>

        {blog.sections.map((section, index) => (
          <section key={index}>
            <h2>{section.heading}</h2>
            <ul>
              {section.content.map((point, idx) => (
                <li key={idx}>{point}</li>
              ))}
            </ul>
          </section>
        ))}

        <section className="conclusion">
          <h2>Conclusion</h2>
          <p>{blog.conclusion}</p>
        </section>
      </div>



      <Footer />
    </div>
  );
};

export default BlogDetails;
